import { render, staticRenderFns } from "./ListaTarjetasPartidos.vue?vue&type=template&id=49405069&scoped=true&"
import script from "./ListaTarjetasPartidos.vue?vue&type=script&lang=js&"
export * from "./ListaTarjetasPartidos.vue?vue&type=script&lang=js&"
import style0 from "./ListaTarjetasPartidos.vue?vue&type=style&index=0&id=49405069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49405069",
  null
  
)

export default component.exports